module.exports = __webpack_public_path__ + "img/icon-weixiu.f49c4ca5.png";